import { RouteObject } from "react-router";

import { GettingStartedLayout } from "@layouts/GettingStarted/GettingStarted.layout";

import { routes } from "../routes";
import { CreateClientManuallyPage } from "./CreateClientManually/CreateClientManually.page";
import { GettingStartedPage } from "./GettingStarted/GettingStarted.page";

export const gettingStartedRoutes = [
  {
    path: routes.portal.gettingStarted.index.$path(),
    Component: GettingStartedLayout,
    handle: {
      breadcrumb: {
        title: "Getting Started",
      },
    },
    children: [
      {
        index: true,
        Component: GettingStartedPage,
      },
      {
        path: routes.portal.gettingStarted.createClientManually.$path(),
        handle: {
          breadcrumb: {
            title: "Create client manually",
          },
        },
        Component: CreateClientManuallyPage,
      },
    ],
  },
] satisfies RouteObject[];
